export interface ISocialMedia {
	facebook?: string;
	instagram?: string;
	twitter?: string;
	linkedIn?: string;
	tiktok?: string;
	others?: string;
	socialMediaChecked?: string;
	googleCheckedDate?: string;
}

export class SocialMediaModel implements ISocialMedia {
	facebook?: string;
	instagram?: string;
	twitter?: string;
	linkedIn?: string;
	tiktok?: string;
	others?: string;
	socialMediaChecked?: string;
	googleCheckedDate?: string;
	constructor(data?: ISocialMedia) {
		this.facebook = data?.facebook || "";
		this.instagram = data?.instagram || "";
		this.twitter = data?.twitter || "";
		this.linkedIn = data?.linkedIn || "";
		this.tiktok = data?.tiktok || "";
		this.others = data?.others || "";
		this.socialMediaChecked = data?.socialMediaChecked || null;
		this.googleCheckedDate = data?.googleCheckedDate || "";
	}
}
